import { ReactNode } from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

import { useQueryErrorResetBoundary } from '@tanstack/react-query'

import { ErrorBoundaryFallback } from './ErrorBoundaryFallback.tsx'

interface ErrorBoundaryProps {
	children: ReactNode
}

/**
 * Wrapper on `react-error-boundary` lib for pass standart FallbackComponent
 * and reset from react-query
 */
export const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
	const { reset } = useQueryErrorResetBoundary()

	return (
		<ReactErrorBoundary
			FallbackComponent={ErrorBoundaryFallback}
			onReset={reset}
		>
			{children}
		</ReactErrorBoundary>
	)
}
